
__webpack_require__.initializeExposesData = {
  moduleMap: {
  "./app": () => {
return Promise.all(/*  | __federation_expose_app */ [__webpack_require__.e("6440"), __webpack_require__.e("6636"), __webpack_require__.e("2618"), __webpack_require__.e("8513"), __webpack_require__.e("7194")]).then(() => (() => (__webpack_require__(2472))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };